import { CSSProperties } from "react";

import { TranslationKeys } from "types/locale";

import { PointOfImpact } from "./types";

const HORIZONTAL_ADJUSTMENT = "7%";
const VERTICAL_ADJUSTMENT = 0;
const CENTER_ALIGNMENT = "50%";
const CORNER_HORIZONTAL_ADJUSTMENT = "10%";
const CORNER_VERTICAL_ADJUSTMENT = "10%";

export const CORNER_POSITIONS: Record<Exclude<PointOfImpact, "Roof">, CSSProperties> = {
  "Left Side": {
    left: HORIZONTAL_ADJUSTMENT,
    top: CENTER_ALIGNMENT,
    transform: "translateY(-50%)",
  },
  "Rear Center": {
    left: CENTER_ALIGNMENT,
    bottom: VERTICAL_ADJUSTMENT,
    transform: "translateX(-50%) rotate(-90deg)",
  },
  "Right Rear Corner": {
    right: CORNER_HORIZONTAL_ADJUSTMENT,
    bottom: CORNER_VERTICAL_ADJUSTMENT,
    transform: "rotate(-155deg)",
  },
  "Right Side": {
    right: HORIZONTAL_ADJUSTMENT,
    top: CENTER_ALIGNMENT,
    transform: "translateY(-50%) rotate(-180deg)",
  },
  "Right Front Corner": {
    right: CORNER_HORIZONTAL_ADJUSTMENT,
    top: CORNER_VERTICAL_ADJUSTMENT,
    transform: "rotate(-205deg)",
  },
  "Front Center": {
    left: CENTER_ALIGNMENT,
    top: VERTICAL_ADJUSTMENT,
    transform: "translateX(-50%) rotate(90deg)",
  },
  "Left Front Corner": {
    left: CORNER_HORIZONTAL_ADJUSTMENT,
    top: CORNER_VERTICAL_ADJUSTMENT,
    transform: "rotate(25deg)",
  },
  "Left Rear Corner": {
    left: CORNER_HORIZONTAL_ADJUSTMENT,
    bottom: CORNER_VERTICAL_ADJUSTMENT,
    transform: "rotate(-25deg)",
  },
} as const;

export const POINT_OF_IMPACT_TRANSLATION_KEYS: Record<PointOfImpact, TranslationKeys> = {
  "Front Center": "damage_area.area.front_center",
  "Right Front Corner": "damage_area.area.front_right_corner",
  "Right Side": "damage_area.area.right_side",
  "Left Side": "damage_area.area.left_side",
  "Left Front Corner": "damage_area.area.front_left_corner",
  "Rear Center": "damage_area.area.rear_center",
  "Right Rear Corner": "damage_area.area.rear_right_corner",
  "Left Rear Corner": "damage_area.area.rear_left_corner",
  Roof: "damage_area.area.roof",
} as const;
